import { render } from "./PlayersGM.vue?vue&type=template&id=8897ed46&scoped=true"
import script from "./PlayersGM.vue?vue&type=script&lang=js"
export * from "./PlayersGM.vue?vue&type=script&lang=js"

import "./PlayersGM.vue?vue&type=style&index=0&id=8897ed46&scoped=true&lang=css"

import exportComponent from "/Users/alexmeister/Documents/GitHub/barq2_0_new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8897ed46"]])

export default __exports__